// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"73a2fbf3","227":"cf2bf772","336":"5b0baf98","512":"a9ad81b1","641":"b6c4e88e","664":"6ecacf2d","724":"93d7a6da","787":"7c188a15","804":"b597e7e0","813":"5dc82470","846":"dbe12488","875":"d93f9e1f"}[chunkId] + ".chunk.js";
};